import { useMutation, useQueryClient } from '@tanstack/react-query';
import Toast from '../components/Toast';
import { jsonPost, jsonPut } from '../api/jsonRequest';
import { queryKeys } from '../query/queryKeys';
import { buildPollUrl } from '../query/queryParams';
import { usePollQuery } from '../query/usePollQuery';

export function useRulers({ enabled = true, pauseRefetch = false } = {}) {
    return usePollQuery({
        queryKey: queryKeys.rulers.list(),
        url: '/api/Ruler/FetchRulers',
        enabled,
        pauseRefetch,
    });
}

export function useRulersForCompany({
    companyId,
    enabled = true,
    pauseRefetch = false,
}) {
    const url = buildPollUrl('/api/Ruler/FetchRulersForCompany', companyId);

    return usePollQuery({
        queryKey: queryKeys.rulers.forCompany(companyId),
        url,
        enabled,
        pauseRefetch,
    });
}

export function useCreateRuler() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload) => {
            const res = await jsonPost('/api/Ruler/PostRuler', payload);
            if (res.status !== 200) {
                throw new Error('Creation failed');
            }
            return res.data;
        },
        onSuccess: (_data, payload) => {
            Toast.fire({
                title: `${payload.rulerSerialNumber} Ruler Generated`,
                icon: 'success',
            });
            void queryClient.invalidateQueries({ queryKey: queryKeys.rulers.all() });
        },
        onError: () => {
            Toast.fire({
                title: 'Creation failed',
                icon: 'error',
            });
        },
    });
}

export function useUpdateRuler() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload) => {
            const res = await jsonPut('/api/Ruler/UpdateRulers', payload);
            if (res.status !== 200) {
                throw new Error('Update failed');
            }
            return res.data;
        },
        onSuccess: (_data, payload) => {
            Toast.fire({
                title: `${payload.RulerSerialNumber} Ruler Updated`,
                icon: 'success',
            });
            void queryClient.invalidateQueries({ queryKey: queryKeys.rulers.all() });
        },
        onError: () => {
            Toast.fire({
                title: 'Update failed',
                icon: 'error',
            });
        },
    });
}

export function useAssignRuler() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (payload) => {
            const res = await jsonPut('/api/Ruler/AssignRulers', payload);
            if (res.status !== 200) {
                throw new Error('Update failed');
            }
            return res.data;
        },
        onSuccess: (_data, payload) => {
            Toast.fire({
                title: `${payload.rulerSerialNumber} Ruler Assigned`,
                icon: 'success',
            });
            void queryClient.invalidateQueries({ queryKey: queryKeys.rulers.all() });
        },
        onError: () => {
            Toast.fire({
                title: 'Update failed',
                icon: 'error',
            });
        },
    });
}
